export default __webpack_public_path__ + "9a6aece04700d42c873273359b815503.woff2";